import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { DisplayText, IconLink, theme, useResponsive } from '@sg/garnish';

export const DeliveryPreferencesFormHeader = (props: DeliveryPreferencesFormHeaderProps) => {
  const { onClose } = props;

  const { formatMessage } = useIntl();
  const { currentBreakpoint } = useResponsive();
  const { isXS } = currentBreakpoint;

  return (
    <View style={isXS ? styles.column : styles.row}>
      {!isXS && (
        <DisplayText sizeMatch={['24', '32']}>
          {formatMessage(messages.deliveryPreferencesTitle)}
        </DisplayText>
      )}

      <View style={styles.icon}>
        <IconLink
          testID="delivery.preferences.close-button"
          name={isXS ? 'IconArrowLeft' : 'IconClose'}
          iconSize={24}
          accessibilityRole="button"
          accessibilityLabel={formatMessage(messages.deliveryPreferencesClose)}
          accessibilityHint={formatMessage(messages.deliveryPreferencesClose)}
          onPress={onClose}
        />
      </View>

      {isXS ? (
        <DisplayText style={styles.header} sizeMatch={['24', '32']}>
          {formatMessage(messages.deliveryPreferencesTitle)}
        </DisplayText>
      ) : null}
    </View>
  );
};

type DeliveryPreferencesFormHeaderProps = Readonly<{
  onClose: () => void;
}>;

const styles = StyleSheet.create({
  icon: {
    width: 24,
    height: 24,
  },
  header: {
    marginTop: theme.spacing['6'],
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  column: {
    flexDirection: 'column',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  deliveryPreferencesTitle: {
    defaultMessage: 'Edit delivery details',
    description: 'Delivery | Preferences | Title',
  },
  deliveryPreferencesClose: {
    defaultMessage: 'Close',
    description: 'Delivery Preferences | Close',
  },
});
